export default __webpack_public_path__ + "img/fvFFjbWB.9b15143b.svg";